import React from "react";

const Charpente = () => {

    return(
        <>
            <div className="">
  {/*section banner*/}
  <section className="be-banner">
    <div className="">
      <p className="be-banner-title">CHIFFRAGE : CHARPENTE TRADITIONNELLE</p>
      <p className="be-centered-p">MUR ET USAGE</p>
    </div>
  </section>
  <div className="container">
    <div className="form-container">
      <div className="form-head">
        <p className="text-center">
          Je sélectionne mon essence de bois pour ma charpente
        </p>
      </div>
      <div className="be-form p-3 p-md-5">
        <form action="">
          <div className="text-center">
            <div className="row select-elements">
              <div className="col-6 col-md-3 mb-4">
                <label>
                  <input
                    type="radio"
                    name="materiau"
                    defaultValue="epicea"
                    className="materiau-radio"
                  />
                  <div className="materiau-wrapper">
                    <img
                      src="/assets/images/bureau-d-etude/brique-parpaing.png"
                      alt="Epicea"
                      style={{ maxWidth: "100%" }}
                    />
                    <div className="rectangle px-4 py-1">
                      <p className="Card-title">EPICEA</p>
                      {/* <p class="Card-sub-title" style="opacity: 1; z-index: 2;">Terrace extérieure</p> */}
                    </div>
                  </div>
                </label>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <label>
                  <input
                    type="radio"
                    name="materiau"
                    defaultValue="douglas"
                    className="materiau-radio"
                  />
                  <div className="materiau-wrapper">
                    <img
                      src="/assets/images/bureau-d-etude/beton.png"
                      alt="Douglas"
                      style={{ maxWidth: "100%" }}
                    />
                    <div className="rectangle px-4 py-1">
                      <p className="Card-title">DOUGLAS</p>
                    </div>
                  </div>
                </label>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <label>
                  <input
                    type="radio"
                    name="materiau"
                    defaultValue="pin-silvestre"
                    className="materiau-radio"
                  />
                  <div className="materiau-wrapper">
                    <img
                      src="/assets/images/bureau-d-etude/pierre.png"
                      alt="Pin sylvestre"
                      style={{ maxWidth: "100%" }}
                    />
                    <div className="rectangle px-4 py-1">
                      <p className="Card-title">PIN SYLVESTRE</p>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div className="mt-4">
            <div className="d-flex flex-column" style={{}}>
              <label htmlFor="" className="label-be">
                Votre charpente sera apparente ou non apparente :
              </label>
              <div className="input-wrapper">
                <input type="text" />
                <span className="unit">mm</span>
              </div>
            </div>
            <div className="to-consider">
              <p>Qualité visuelle accrue pour les bois apparents</p>
            </div>
          </div>
          <div className="other-choice">
            <div className="row">
              <div className="col-6 col-md-3">
                <div className="other-choice-box">
                  <p className="text-center">AUTRE CHOIX</p>
                </div>
              </div>
              <div
                className="d-flex flex-column mt-5 mt-md-0"
                style={{ maxWidth: 450 }}
              >
                <label htmlFor="" className="label-be">
                  Quel typologie de mur ?
                </label>
                <input type="text" />
                <label htmlFor="" className="label-be mt-auto">
                  Indiquez l'épaisseur
                </label>
                {/* <input type="text"> */}
                <div className="input-wrapper">
                  <input type="text" />
                  <span className="unit">mm</span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div className="form-container">
      <div className="form-head">
        <p className="text-center">
          Je sélectionne la typologie de ferme pour ma charpente
        </p>
      </div>
      <div className="be-form p-3 p-md-5">
        <form action="">
          <div className="text-center">
            <div className="row select-elements">
              <div className="col-6 col-md-3 mb-4">
                <label className="w-100">
                  <input
                    type="radio"
                    name="materiau"
                    defaultValue="ferme-traditionnelle"
                    className="materiau-radio"
                  />
                  <div className="materiau-wrapper farm-typology-card">
                    <div className="charpente-img">
                      <img
                        src="/assets/images/bureau-d-etude/charpente-1.png"
                        alt="Ferme traditionnelle"
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                    <div className="white-rectangle px-1 px-md-4 py-1">
                      <p className="Card-title text-center">
                        FERME TRADITIONELLE
                      </p>
                      {/* <p class="Card-sub-title" style="opacity: 1; z-index: 2;">Terrace extérieure</p> */}
                    </div>
                  </div>
                </label>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <label className="w-100">
                  <input
                    type="radio"
                    name="materiau"
                    defaultValue="panne-passante"
                    className="materiau-radio"
                  />
                  <div className="materiau-wrapper farm-typology-card">
                    <div className="charpente-img">
                      <img
                        src="/assets/images/bureau-d-etude/panne-passante.png"
                        alt="Panne passante"
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                    <div className="white-rectangle px-1 px-md-4 py-1">
                      <p className="Card-title text-center">PANNES PASSANTES</p>
                      {/* <p class="Card-sub-title" style="opacity: 1; z-index: 2;">Terrace extérieure</p> */}
                    </div>
                  </div>
                </label>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <label className="w-100">
                  <input
                    type="radio"
                    name="materiau"
                    defaultValue="chevrons-porteurs"
                    className="materiau-radio"
                  />
                  <div className="materiau-wrapper farm-typology-card">
                    <div className="charpente-img">
                      <img
                        src="/assets/images/bureau-d-etude/chevrons-porteurs.png"
                        alt="chevrons-porteurs"
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                    <div className="white-rectangle px-1 px-md-4 py-1">
                      <p className="Card-title text-center">
                        CHEVRONS PORTEURS
                      </p>
                      {/* <p class="Card-sub-title" style="opacity: 1; z-index: 2;">Terrace extérieure</p> */}
                    </div>
                  </div>
                </label>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <label className="w-100">
                  <input
                    type="radio"
                    name="materiau"
                    defaultValue="ferme-banane"
                    className="materiau-radio"
                  />
                  <div className="materiau-wrapper farm-typology-card">
                    <div className="charpente-img">
                      <img
                        src="/assets/images/bureau-d-etude/ferme-banane.png"
                        alt="Ferme banane"
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                    <div className="white-rectangle px-1 px-md-4 py-1">
                      <p className="Card-title text-center">FERME BANANE</p>
                      {/* <p class="Card-sub-title" style="opacity: 1; z-index: 2;">Terrace extérieure</p> */}
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div className="form-container">
      <div className="form-head">
        <p className="text-center">
          Souhaitez-vous le chiffrage d’éléments complémentaires ?
        </p>
      </div>
      <div className="be-form p-3 p-md-5">
        <form action="">
          <p className="be-description">
            Chez Rullier Bois, retrouvez de nombreuses fournitures pour réaliser
            entièrement votre projet : <br />
            Menuiseries, Parquet, Bardage, Isolation, Lambris et bien plus
            encore. <br />
            Pour découvrir tous ces produits, visitez notre service de projet en
            1 clic ou directement sur notre site ou en <br />
            agence Rullier Bois.
          </p>
        </form>
      </div>
    </div>
  </div>
  {/* content close */}
  <a href="#" id="back-to-top" className="show" />
</div>

        </>
    )

}

export default Charpente;